export default {
  'component.globalHeader.help': '帮助',
};
